import React from "react";
import Box from "@mui/material/Box";
import SearchInput from "../../../common/SearchInputField";

export default function CustomerToolbar({
  searchQuery,
  onSearchChange,
}) {
  return (
    <Box sx={{ px: "24px", pt: "24px", pb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Box sx={{ width: 296, flex: "0 0 296px" }}>
          <SearchInput
            placeholder="Search customers..."
            value={searchQuery}
            className="SearchInputField-article"
            onChange={(e) => onSearchChange(e.target.value)}
            iconPosition="left"
            iconGap={8}
            style={{ width: 296 }}
            inputStyle={{ width: 296 }}
            noTitle
            iconVariant="people"
          />
        </Box>
      </Box>
    </Box>
  );
}
